"use client";

import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
} from "lucide-react";
import Cookies from "js-cookie";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/redux/features/auth-slice";
import { useRouter } from "next/navigation";
import { RootState } from "@/redux/store";
import { getInitials } from "@/utils/global";
import { NavUsage } from "@/components/shared/credit-banner";

export function NavOrg() {
  const org = useSelector((state: RootState) => state.user.user?.organization);
  const orgInitials = getInitials(org?.name);

  return (
    <>
    <NavUsage />
    <SidebarMenu className="mb-2">
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground md:h-8 md:p-0"
        >
          <Avatar className="h-8 w-8 rounded-none">
            <AvatarImage src={org?.logo_url || ""} alt={org?.name || ""} />
            <AvatarFallback className="rounded-none bg-transparent" suppressHydrationWarning>
              <Image
                src="/Icon_logo_light.svg"
                alt="Implement AI"
                width={32}
                height={32}
                unoptimized
                className="object-contain dark:hidden"
              />
              <Image
                src="/Icon_logo_dark.svg"
                alt="Implement AI"
                width={32}
                height={32}
                unoptimized
                className="object-contain hidden dark:block"
              />
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight">
            <span className="truncate text-base font-bold" suppressHydrationWarning>{org?.name}</span>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
    </>
  );
}
